import React from 'react'

import { Box } from 'widgets/Box'
import { LoadingSpinner } from 'widgets/LoadingSpinner'
import { Text } from 'widgets/Text'

export const LoadingView = () => {
  return (
    <Box flex={1} justifyContent='center' align='center'>
      <LoadingSpinner />
      <Box padding={{ vertical: 'sm' }}>
        <Text>Loading...</Text>
      </Box>
    </Box>
  )
}
